module.exports = __webpack_public_path__ + "img/b2.ea076840.png";